import Vue from 'vue';
export default Vue.extend({
    props: {
        items: {
            type: Array,
            default: function () { return []; }
        },
        limit: {
            type: Number,
            default: 4
        },
        limitMd: {
            type: Number,
            default: 6
        }
    },
    data: function () {
        return {
            visibleItems: 0
        };
    },
    created: function () {
        if (this.onDesktopBreakPoint) {
            this.visibleItems = this.limitMd;
        }
        else {
            this.visibleItems = this.limit;
        }
    },
    computed: {
        limitedItems: function () {
            return this.items.slice(0, this.visibleItems);
        },
        onDesktopBreakPoint: function () {
            return window.matchMedia('(min-width: 768px)').matches;
        }
    },
    methods: {
        showMore: function () {
            if (this.onDesktopBreakPoint) {
                this.visibleItems += this.limitMd;
            }
            else {
                this.visibleItems += this.limit;
            }
        }
    }
});
